import { render, staticRenderFns } from "./foodRecheck.vue?vue&type=template&id=df2cde84&scoped=true&"
import script from "./foodRecheck.vue?vue&type=script&lang=js&"
export * from "./foodRecheck.vue?vue&type=script&lang=js&"
import style0 from "./foodRecheck.vue?vue&type=style&index=0&id=df2cde84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2cde84",
  null
  
)

export default component.exports